import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { UpdateCampaignCreatorLabel } from '../api';

type UpdateCampaignCreatorLabelMutationRequest = {
  campaignId: string;
  creatorId: string;
  label: string | null;
};

export const useUpdateCampaignCreatorLabelMutation = () => {
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: ({ campaignId, creatorId, label }: UpdateCampaignCreatorLabelMutationRequest) =>
      UpdateCampaignCreatorLabel(campaignId, creatorId, label),
    onSettled(_data, _error, variables) {
      queryClient.invalidateQueries({
        queryKey: queryKeys.campaign.creatorsRoot(variables.campaignId),
        refetchType: 'none',
      });

      queryClient.invalidateQueries({
        queryKey: queryKeys.campaign.creatorCountsRoot(variables.campaignId),
        refetchType: 'none',
      });
    },
  });
};
